// AI Generated Component
import { Component, Input, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { PAGE_FIX_SELECTOR_QUERIES } from '@client/app/modules/page-fix/constants/page-fix-selector-queries';
import { PAGE_FIX_FIXABLE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-fixable-types';
import { PAGE_FIX_CHANGE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-change-types';
import { PAGE_FIX_EVENT } from '@client/app/modules/page-fix/constants/page-fix-event';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';

@Component({
    selector: 'page-fix-form-skip-to-content-options',
    templateUrl: './page-fix-form-skip-to-content-options.component.html',
    standalone: false,
})
export class PageFixFormSkipToContentOptionsComponent implements OnInit, OnDestroy {
    @Input() monPageFix?: any;
    @Input() monPageFixId!: any;
    @Input() monPageFixSelector!: any;
    @Input() monType!: any;
    @Input() monSelected!: any;
    @Input() monOrder!: any;

    selectors: string[] = [];
    skipToContentText: string = '';
    saving: boolean = false;
    requestPreparePayloadId: number = 0;

    constructor (
        private monEventService: MonEventService,
        private elementRef: ElementRef,
    ) {}

    ngOnInit (): void {
        this.requestPreparePayloadId = 0;
        this.monEventService.run(PAGE_FIX_EVENT.REGISTER_VIEW, this.elementRef.nativeElement, {
            type: this.monType,
            order: this.monOrder,
            selected: this.monSelected,
        });
        this.selectors = [''];
        this.skipToContentText = 'Skip to Content';
        if (this.monPageFix) {
            this.selectors = JSON.parse(this.monPageFix.change.target);
            this.skipToContentText = this.monPageFix.change.value;
        }
        this.saving = false;
        this.setupListeners();
    }

    ngOnDestroy (): void {
        this.monEventService.run(PAGE_FIX_EVENT.UNREGISTER_VIEW, this.elementRef.nativeElement);
        this.monEventService.remove(this.requestPreparePayloadId);
    }

    private setupListeners (): void {
        this.requestPreparePayloadId = this.monEventService.addListener(PAGE_FIX_EVENT.REQUEST_PREPARE_PAYLOAD, () => {
            const change = {
                attribute: 'button',
                check_id: this.monPageFixId,
                value: this.skipToContentText,
                target: JSON.stringify(this.selectors.filter(Boolean)),
            };
            let payload: any;
            if (this.monPageFix) {
                payload = { change: change };
            } else {
                payload = {
                    change: change,
                    selector: PAGE_FIX_SELECTOR_QUERIES.query_selector + ';' + this.monPageFixSelector,
                    fixable_type: PAGE_FIX_FIXABLE_TYPES.accessibility_check,
                    fixable_id: this.monPageFixId,
                    change_type: PAGE_FIX_CHANGE_TYPES.element + ':skip-to-content',
                };
            }
            this.monEventService.run(PAGE_FIX_EVENT.REQUEST_SUBMIT, payload);
        });
    }

    addSelector (): void {
        this.selectors.push('');
    }

    removeSelector (index: number): void {
        this.selectors.splice(index, 1);
    }

    resetText (): void {
        this.skipToContentText = 'Skip to Content';
    }

    trackByIndex (index: number): number {
        return index;
    }
}
